export abstract class BaseModel {
  public _id: any;

  constructor() {
    this._id = Math.round(Math.random() * 10000);
  }

  get id(): any {
    return this._id;
  }

  set id(value: any) {
    this._id = value;
  }

  public stringify(): string {
    return 'The model ' + this.constructor.name + ' hasn\'t implemented the method stringify';
  }

  /**
   * Return if the model is equals to received one. (This method must be override from subclasses)
   */
  public equals(o: BaseModel): boolean {
    if (!o) {
      return false;
    }

    // normal is base only to instance compactions (it's the same memory/instance)
    return this.id === o.id;
  }
}
